import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import HeaderInfo from "../common/headerinfo";
import RightView from "../common/rightview";

class WebDataResult extends React.Component {
  constructor(props) {
    super(props);
  }

  formatNumber = number => {
    if (
      (number.toString().split(".")[0] &&
        number.toString().split(".")[0].length > 9) ||
      (number.toString().split(".")[1] &&
        number.toString().split(".")[1].length > 6)
    ) {
      return number.toExponential(3).toUpperCase();
    } else return number;
  };

  myToFixed = (number, dp) => {
    let suffixZeros = "";
    if (Number.isInteger(number)) {
      for (let i = 0; i < dp; i++) {
        suffixZeros = suffixZeros + "0";
      }
      return `${number}.${suffixZeros}`;
    } else {
      return parseFloat(number).toFixed(dp);
    }
  };

  calculatePercentage = (numberofCount, totalFrames) => {
    let res =
      isNaN((numberofCount / totalFrames) * 100) ||
        !isFinite((numberofCount / totalFrames) * 100)
        ? 0
        : Number.isInteger((numberofCount / totalFrames) * 100)
          ? (numberofCount / totalFrames) * 100
          : ((numberofCount / totalFrames) * 100).toFixed(3);
    return this.myToFixed(res, 3);
  };

  render() {
    const {
      classes,
      result,
      subtest,
      subtestSubTestSettingsResults,
      translate
    } = this.props;

    return subtestSubTestSettingsResults &&
      subtestSubTestSettingsResults.subtesttypeid ? (
        <div ref="container">
          <HeaderInfo
            translate={translate}
            subtestSubTestSettingsResults={subtestSubTestSettingsResults}
          />
          <Grid container>
            <Grid item xs={6}>
              <Table className={classes.table} style={{ marginTop: "30px" }}>
                <TableHead>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {translate("result_no_of_web_sessions")}
                    </TableCell>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {subtestSubTestSettingsResults.sessions}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {translate("result_error_limil")}
                    </TableCell>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {`${subtestSubTestSettingsResults &&
                        subtestSubTestSettingsResults.errors != null
                        ? this.formatNumber(subtestSubTestSettingsResults.errors)
                        : ""} ${subtestSubTestSettingsResults && (subtestSubTestSettingsResults.losslimitcount || subtestSubTestSettingsResults.losslimitcount == 0) ? ('/ ' + this.formatNumber(subtestSubTestSettingsResults.losslimitcount)) : ''}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {translate("result_total_bandwidth2")}:
                  </TableCell>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {(subtestSubTestSettingsResults.totalbandwidth ||
                        subtestSubTestSettingsResults.totalbandwidth == 0) &&
                        this.myToFixed(
                          subtestSubTestSettingsResults.totalbandwidth,
                          4
                        )}{" "}
                    Gb/s
                  </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {translate("result_info_rate")}
                    </TableCell>
                    <TableCell width="50%" className={classes.tablecontent_first}>
                      {(subtestSubTestSettingsResults.inforate ||
                        subtestSubTestSettingsResults.inforate == 0) &&
                        this.myToFixed(
                          subtestSubTestSettingsResults.inforate,
                          2
                        )}{" "}
                    Mb/s
                  </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      width="50%"
                      className={classes.tablecontent_first}
                      rowSpan={2}
                    >
                      {translate("result_tx_frames")}
                    </TableCell>
                    <TableCell
                      width="50%"
                      className={classes.tablecontent_first}
                      rowSpan={2}
                    >
                      <div p={1} className={classes.tablecontent_first}>
                        {subtestSubTestSettingsResults &&
                          subtestSubTestSettingsResults.txcount != null
                          ? this.formatNumber(
                            subtestSubTestSettingsResults.txcount
                          )
                          : ""}
                      </div>
                      <div p={1} className={classes.tablecontent_first_percent}>
                        {this.calculatePercentage(
                          subtestSubTestSettingsResults.txcount,
                          subtestSubTestSettingsResults.totalframes
                        )}
                      %
                    </div>
                    </TableCell>
                  </TableRow>
                  <br />
                  <TableRow>
                    <TableCell
                      width="50%"
                      className={classes.tablecontent_first}
                      rowSpan={2}
                    >
                      {translate("result_rx_frames")}
                    </TableCell>
                    <TableCell
                      width="50%"
                      className={classes.tablecontent_first}
                      rowSpan={2}
                    >
                      <div p={1} className={classes.tablecontent_first}>
                        {subtestSubTestSettingsResults &&
                          subtestSubTestSettingsResults.rxcount != null
                          ? this.formatNumber(
                            subtestSubTestSettingsResults.rxcount
                          )
                          : ""}
                      </div>
                      <div p={1} className={classes.tablecontent_first_percent}>
                        {this.calculatePercentage(
                          subtestSubTestSettingsResults.rxcount,
                          subtestSubTestSettingsResults.totalframes
                        )}
                      %
                    </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            <Grid item xs={6}>
              <Table className={classes.table}>
                <RightView
                  translate={translate}
                  subtestSubTestSettingsResults={subtestSubTestSettingsResults}
                />
              </Table>
            </Grid>
          </Grid>
        </div>
      ) : (
        <Typography type="button">{translate("no_data_sg")}</Typography>
      );
  }

  componentWillUnmount() {
    this.props.clearSubTestSettingsResult();
  }

  componentWillMount() {
    const { getsubtestSubTestsettingsResults, subtest, pager } = this.props;

    getsubtestSubTestsettingsResults(pager.jid, pager.tid, subtest);
  }
  componentWillReceiveProps(nextProps) {
    const { getsubtestSubTestsettingsResults, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getsubtestSubTestsettingsResults(pager.jid, pager.tid, subtest);
    }
  }
}

export default withStyles(styles)(WebDataResult);
